// Shared configuration for the assessment Wizard + Results so SBA (Senior
// Benefits) and Nauticus Life can reuse the SAME components. SBA_CONFIG
// reproduces the original SBA copy exactly so that experience is unchanged.
import { SBALogo } from "@/components/SBALogo";
import { NauticusLogo } from "@/components/NauticusLogo";

export const SBA_CONFIG = {
  journeyType: "medicare",
  brandCode: "sba",
  templateCode: "senior_medicare",
  homePath: "/sba",
  assessmentPath: "/sba/assessment",
  resultsPath: "/sba/assessment/results",
  Logo: SBALogo,
  logoClass: "h-8 sm:h-10",
  logoAria: "Senior Benefit Advisors home",
  homeBtnLabel: "Back to Senior Benefit Advisors",
  wizardTag: "No cost. No obligation.",
  resultsTag: "Your Benefits Intelligence",
  intelligenceName: "Senior Benefits Intelligence",
  pictureTitle: "Your Medicare picture",
  resultsSubtitle:
    "Based on what you told us, Nauticus has mapped out the areas of your benefits picture that may be worth reviewing.",
  savePrompt: "Want to save your Senior Benefits Intelligence?",
  saveSub: "Create your free account so you can come back to your results anytime.",
  attentionTitle: "Areas worth reviewing",
  showRecommendations: true,
  prioritiesFirst: false,
  consent: {
    self: "I agree that Senior Benefit Advisors may contact me by phone, text, or email about my Medicare review. I understand consent is not a condition of purchase and I can opt out anytime.",
    advisor_assisted: "I agree that a licensed Senior Benefit Advisors specialist may contact me by phone, text, or email to help review my Medicare options. I understand consent is not a condition of purchase and I can opt out anytime.",
  },
  welcome: {
    eyebrow: "About 7 minutes",
    title: "Let's take a look at your benefits picture.",
    subtitle:
      "A few simple questions help us understand what matters most to you. There's no cost and no obligation — this is about helping you see your options clearly.",
    bullets: ["No cost. No obligation.", "Plain language — no insurance jargon.", "Your information stays private and secure."],
    startBtn: "Start my assessment",
    trustline: "Licensed Senior Benefit Advisors specialists — here to help, never to pressure.",
  },
  showExplorePlans: true, // Medicare-only: employer/group benefits catalog downstream
  skipWelcome: false,
};

export const LIFE_CONFIG = {
  journeyType: "life",
  brandCode: "nauticus_life",
  templateCode: "nauticus_life",
  homePath: "/life",
  assessmentPath: "/life/assessment",
  resultsPath: "/life/assessment/results",
  Logo: NauticusLogo,
  logoClass: "",
  logoAria: "Nauticus home",
  homeBtnLabel: "Back to Nauticus Life",
  wizardTag: "No cost. No obligation.",
  resultsTag: "Your Protection Intelligence",
  intelligenceName: "Life & Protection Intelligence",
  pictureTitle: "Your protection picture",
  resultsSubtitle:
    "Based on what you told us, Nauticus has mapped out the parts of your protection picture that may be worth reviewing.",
  savePrompt: "Want to save your Life & Protection Intelligence?",
  saveSub: "Create your free account so you can come back to your results anytime.",
  attentionTitle: "What deserves attention",
  showRecommendations: false,
  prioritiesFirst: true,
  consent: {
    self: "I agree that Nauticus may contact me by phone, text, or email about my life insurance review. I understand consent is not a condition of purchase and I can opt out anytime.",
    advisor_assisted: "I agree that a licensed insurance agent may contact me by phone, text, or email to help review my life insurance options. I understand consent is not a condition of purchase and I can opt out anytime.",
  },
  welcome: {
    eyebrow: "About 5 minutes",
    title: "Let's look at your protection picture.",
    subtitle:
      "A few simple questions help us understand who you're protecting and what matters most. There's no cost and no obligation — and we'll never ask health or medical questions here.",
    bullets: ["No cost. No obligation.", "No medical or health questions.", "Your information stays private and secure."],
    startBtn: "Start my review",
    trustline: "Nauticus helps you understand your options — a licensed insurance agent is here when you want one.",
  },
  showExplorePlans: false,
  // Landing page already provides the intro/reassurance; the ZIP submit IS the start,
  // so skip the wizard's welcome screen and go straight to the first question.
  skipWelcome: true,
};
